import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Overlay } from '@angular/cdk/overlay';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { Location } from '@angular/common';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { TclcHistoryComponent } from '../tclc-history/tclc-history.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { Observable } from 'rxjs/internal/Observable';
import { Subscriber } from 'rxjs';

@Component({
  selector: 'app-tclc-approval',
  templateUrl: './tclc-approval.component.html',
  styleUrls: ['./tclc-approval.component.scss']
})

export class TclcApprovalComponent implements OnInit, AfterViewInit {
  Tclcdata: any;
  stepperForm: FormGroup;
  personalDetailsForm: FormGroup;
  CertScrutinyForm: FormGroup;
  contactDetailsForm: FormGroup;
  reservationsDetailsForm: FormGroup;
  qualificationDetailsForm: FormGroup;
  additionalDetailsForm: FormGroup;
  photoSignDetailsForm: FormGroup;
  admissionDetailsForm: FormGroup;
  documentDetailsForm: FormGroup;
  marritalList: any;
  filteredmarritalstatusList: any;
  filteredBloodGroupList: any;
  bloodgroupList: any;
  filteredGenderList: any;
  genderList: any;
  isDivShow: boolean;
  isreadonly = true;
  dialogRef1: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  StateCodeList: any;
  filteredListState: any;
  districtCodeList: any;
  filteredListDistrict: any;
  qualList: any;
  regionList: any;
  filteredRegionList: any;
  filteredDomicileList: any;
  domicileList: any;
  filteredNationalityList: any;
  nationalityList: any;
  filteredMinorityList: any;
  minorityList: any;
  categoryList: any[];
  filteredCategoryList: any[];
  religionList: any;
  filteredReligionList: any;
  specialAbledList: any;
  filteredspecialAbledList: any;
  orphanTypeList: any;
  filteredorphanTypeList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  userImage: any;
  signatureImage: any;
  proId: any;
  facultyList: any;
  filteredFacultyList: any;
  courseList: any;
  filteredCourseList: any;
  courseStreamList: any;
  filteredStreamList: any;
  examList: any;
  filteredExamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  ducumentList: any;
  ScrutinyLevel: 0;
  UserId: 0;
  ScrutinyId: 0;
  StudentId: 0;
  CoCode: 0;
  CgCode: 0;
  SessionId: 0;
  LoginName: any;
  FirstName: any;
  MiddleName: any;
  LastName: any;
  from: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  mothertoungList: any;
  filteredMotherToungList: any;
  BranchId = 0;
  subList: any;
  filteredSubList: any;
  PassYearList: any;
  filteredPassYearList: any;
  courseLevelList: any;
  filteredcourseLevelList: any;
  courseQualList: any;
  filteredcourseList: any;
  boardUniList: any;
  filteredboardUniList: any;
  Subs = false;
  OptSub = false;
  Min: any;
  Max: any;
  SubjectName: any[] = [];
  ErrorMessage: string;
  optData: any;
  GroupData: any;
  SubError = false;
  selectedValues: any[] = [];
  Subjects: any[] = [];
  selectedCheckboxes: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  years: number[] = this.generateYears(1975, new Date().getFullYear());
  newSelectedValues = [];
  Sub: any[] = [];
  AllSub: any[] = [];
  selectedOptions: any = [];

  SubjectData = [];
  StateCodeListP: any;
  filteredListStateP: any;
  districtCodeListP: any;
  filteredListDistrictP: any;
  SessionFilterList: any;
  sessionList: any;
  filteredtehasilPList: any;
  tehasilPList: any;
  tehasilCList: any[];
  filteredtehasilCList: any[];
  filteredListDistrictC: any;
  districtCodeListC: any;
  filteredListStateC: any;
  StateCodeListC: any;
  PCountryCodeList: any;
  filteredListPCountryCode: any;
  CfilteredListCountryCode: any;
  CCountryCodeList: any;
  SRList: any;
  filteredSR: any;
  dialogRef: MatDialogRef<any>;
  isformreadonly = true;
  examData: any;
  CertList: any;
  filteredCertList: any;
  CertScrId: any;
  DestClgTrue: any;
  AdmFeesPaid: boolean;
  FeesData: any;
  userPermission: any;
  StudentName: string;
  TranscriptData: any;
  TclcDoc: boolean;
  TclcDocData: any;
  Transcript: boolean;
  ProvisionalData: any;
  Provisional: boolean;
  ProvisionalCourse: any;
  ishardcopy: boolean;
  fileName: string;
  errormessage: string;
  uploadDoc: any;
  fileUploads: any;
  RankData: any;
  filename: any;
  fileUploadData: any;
  showReport: boolean;
  HardCopy: any;
  Specialization: boolean;
  InternDate: boolean;
  Internship: boolean;
  Copy: string;
  isPhdCourseSelected: boolean = false;
  courseFullName: any;
  constructor(private dialog: MatDialog, private location: Location,
    private fb: FormBuilder, public router: Router,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe, private overlay: Overlay,
    private route: ActivatedRoute) { }
  // studentId = 1084
  // studentId = 22
  personalDetailsFormArray;
  contactDetailsFormArray;
  reservationsDetailsFormArray;
  qualificationDetailsFormArray;
  additionalDetailsFormArray;
  admissionDetailsFormArray;
  isOpen = true;
  showchat = false;
  showchattt = true
  readonly = true;
  isStuCasteDisable = false
  isStuCasteCertDisable = false
  isStuCasteValCertDisable = false;
  isStuNonCrmValDtDisable = false;
  isStuOrphanTypeDisable = false;
  isStuSpecialAbledTypeDisable = false;
  isStuMinorityTypeDisable = false;
  isStuNonCrmCertDisable = false
  isStuMinorityType2Disable = false;
  isStuInHouseDisable = false;
  isStuMinorityDisable = false;
  currentdate: any;
  isStuNonCrmValDtDisable2 = false;
  disableMinority = true;
  resultNotDec = false;
  UpdateBtn = false;
  SaveDisabled = false;
  tclc = []
  ScrutinyFormArray: any = {};
  personalData: boolean = false;
  ContactData: boolean = false;
  ReservationData: boolean = false;
  AdditionalData: boolean = false;
  QualificationData: boolean = false;
  AdmissionData: boolean = false;
  DocumentData: boolean = false;
  PhotoSignData: boolean = false;
  ScrutinyData: boolean = false;
  DocUploaded: boolean = false;
  ShowPersonal: boolean = false;
  ShowContact: boolean = false;
  ShowReservation: boolean = false;
  ShowQualify: boolean = false;
  ShowAddit: boolean = false;
  ShowPhoto: boolean = false;
  ShowAdmission: boolean = false;
  ShowDoc: boolean = false;
  courseName:any;
  courseCode:any;
  sortSequence:any;
  ReportCoCode:any;

  ngOnInit(): void {

    this.stepperForm = new FormGroup({

      personalDetailsForm: new FormControl(),
      CertScrutinyForm: new FormControl(),
      contactDetailsForm: new FormControl(),
      reservationsDetailsForm: new FormControl(),
      qualificationDetailsForm: new FormControl(),
      additionalDetailsForm: new FormControl(),
      photoSignDetailsForm: new FormControl(),
      admissionDetailsForm: new FormControl(),
      documentDetailsForm: new FormControl(),
      DocumentFile: new FormControl(),
      FileUpload: new FormControl()
    });
    this.Tclcdata = this.umsService.getTclcData();
    
    this.loadsettingspage(this.Tclcdata['CertType']);
  }

  loadsettingspage(CertType) {
    let FormName = '';
    if (CertType == 'PC') {
      FormName = 'Provisional';
    }
    else if (CertType == 'OPC') {
      FormName = 'Passing';
    }
    else if (CertType == 'MC') {
      FormName = 'Migration';
    }
    else if (CertType == 'RC') {
      FormName = 'RankCert';
    }
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = FormName;
    // payload['Inst'] = sessionStorage.getItem('Inst');
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      this.ScrutinyFormArray = res.data.reduce((result, item) => {
        result[item.FormControlName] = result[item.FormControlName] || [];
        result[item.FormControlName].push(item);
        return result;
      }, {});
      this.ScrutinyData = true;
      this.initialize()

    });
  }

  initialize() {
    this.tclc = []
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.fetchCertStatus()
    this.Tclcdata = this.umsService.getTclcData();
    if (this.Tclcdata['CertStatus'] === 'APPAP') {
      this.ishardcopy = true;
    }
    else {
      this.ishardcopy = false;
    }
    this.tclc.push(this.Tclcdata)
    console.log('this.tclc', this.tclc);

    this.getTclcDocs(this.Tclcdata['StuId'])
    this.DestClgTrue = this.tclc[0]['CertType']
    this.StudentId = this.Tclcdata['StuId']
    // this.checkLock();
    this.currentdate = new Date();
    this.courseFullName = this.Tclcdata.CourseName
    console.log('this.courseFullName',this.courseFullName)
    this.courseName = this.Tclcdata.CourseCode

    console.log('this.courseName',this.courseName)
    if(this.courseName === 'PHD'){
    this.isPhdCourseSelected = true;
    }
    else{
      this.isPhdCourseSelected = false;
    }
    if (this.from === 'report') {
      this.showchattt = false
      this.isformreadonly = true;
      this.UpdateBtn = true;
    } else {
      this.showchattt = true
      this.isformreadonly = false;
      this.UpdateBtn = false;
    }

    this.getScrData()

    let id = '';
    Object.keys(this.ScrutinyFormArray).forEach((tabKey) => {
      const tabData = this.ScrutinyFormArray[tabKey]; // Array of data for each tab
      switch (tabKey) {
        case 'PersonalTab':
          // Handle PersonalTab
          if (tabData[0]?.FormVisible) {
            this.personalDetailsForm = new FormGroup({
              StuRgNo: new FormControl(this.StudentId),
              StuId: new FormControl(""),
            });
            this.personalDetails();
          }
          break;
        case 'ContactTab':
          if (tabData[0]?.FormVisible) {
            this.contactDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuAddrId: new FormControl(""),
            });
            this.contactDetails();

          }
          break;
        case 'ReservationTab':
          if (tabData[0]?.FormVisible) {
            this.reservationsDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuResId: new FormControl(''),
            });
            this.reservationDetails();

          }
          break;
        case 'AdditionalTab':
          if (tabData[0]?.FormVisible) {
            this.additionalDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuExtraId: new FormControl(),
            });
            this.prepopulationA();
          }
          break;
        case 'QualificationTab':
          if (tabData[0]?.FormVisible) {
            this.qualificationDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuQualId: new FormControl(),
            });
            this.prepopulationQ();
          }
          break;
        case 'PhotoSignTab':
          if (tabData[0]?.FormVisible) {
            this.photoSignDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuRgNo: new FormControl(this.StudentId),
              StuPhoto: new FormControl(''),
              StuSignature: new FormControl(''),

            });
            this.prepopulationPS();
          }
          break;
        case 'AdmissionTab':
          if (tabData[0]?.FormVisible) {
            this.admissionDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
            });
            this.admissionDetails();

          }
          break;
        case 'DocumentTab':
          if (tabData[0]?.FormVisible) {
            this.documentDetailsForm = this.fb.group({
              "StuRemarkConfirm": new FormControl(''),
              "StuRemarkCheck": new FormControl(''),
              arrData: this.fb.array([]),
            });
            this.fetchDocument();
          }
          break;
        case 'ExamPassedTab':
          if (tabData[0]?.FormVisible) {
            this.prepopulationP();
          }
          break;
        case 'AdmissionFeeTab':
          if (tabData[0]?.FormVisible) {
            this.prepopulationAD()
          }
          break;
        // Add cases for other tabs as needed
        default:
          break;
      }
    });
    this.CertScrutinyForm = new FormGroup({
      Comment: new FormControl(''),
      CertStatus: new FormControl('', Validators.required),
      DocumentFile: new FormControl(),
      FileUpload: new FormControl(Validators.required),
      totStudent: new FormControl(),
      rank: new FormControl(),
    });
    this.fetchCourseLevel();
    this.fetchPassYear();
    this.fetchCourseForQual();
    this.fetchBoardUni();
    if ((this.Tclcdata['CertStatus'] == 'APR' || this.Tclcdata['CertStatus'] == 'REJ') && this.Tclcdata['CertType'] != 'ADMC') {
      this.SaveDisabled = true;
      this.showReport = false
    }
    else if (this.Tclcdata['CertStatus'] == 'APPAP' && (this.Tclcdata['CertType'] == 'ADMC' || this.Tclcdata['CertType'] == 'PC' || this.Tclcdata['CertType'] == 'RC')) {
      this.SaveDisabled = true;
      this.showReport = true
    }
    else {
      this.SaveDisabled = false;
      this.showReport = false
    }


    if (this.Tclcdata['CertType'] === "RC") {
      this.getRank(this.Tclcdata['StuId'])
      this.Internship = false;
      this.Specialization = false;
    }
    else if (this.Tclcdata['CertType'] === "MC") {
      this.getMigration(this.Tclcdata['StuId'])
      this.Internship = false;
      this.Specialization = false;
    }
    else if (this.Tclcdata['CertType'] === "PC") {
      this.getProvisional(this.Tclcdata['StuId'])
      this.Internship = true;
      this.Specialization = true;
    }
    else if (this.Tclcdata['CertType'] === "OPC") {
      this.getPassing(this.Tclcdata['StuId'])
      this.Internship = true;
      this.Specialization = true;
    }

    // this.getCertificateCourses()
  }

  ngAfterViewInit(): void {

  }
  personalDetails() {
    this.prepopulationP();
    this.ageCalculate();
    this.fetchMarritalStatus();
    this.fetchBloodGroup();
    this.fetchGender();
    this.fetchMotherTounge();
  }

  contactDetails() {
    this.prepopulationC();
    this.fetchCountry();
    this.fetchDistrict();
    this.fetchState();
    this.fetchNationality();
    this.fetchDomicile();
    this.fetchRegion();
    this.fetchCountryP();
    this.fetchCountryC()
  }

  reservationDetails() {
    this.prepopulationR();
    this.fetchReligion();
    this.fetchSpAbled();
    this.fetchorphanType();
    this.fetchConstiCate();
    this.fetchSocialReservation();

  }

  admissionDetails() {
    this.prepopulationAD();
    this.getFacultyData();
    this.fetchStudyMode();
    this.fetchStudentType();
    this.getSessionData()
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  prepopulationP() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {

      if (res.status) {
        if (res.data.length > 0) {
          this.getRegData(res.data[0])
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageP(res);
        } else {
          this.loadsettingspageP();
        }
      } else {
        this.spinner.hide();
        this.ShowPersonal = false;
        this.loadsettingspageP();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowPersonal = false;
    })

  }
  prepopulatedatapageP(e) {
    this.StudentName = e.data[0]['StuFirstNameEng'] + ' ' + e.data[0]['StuMidNameEng'] + ' ' + e.data[0]['StuLastNameEng']
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';

    this.personalDetailsForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.personalDetailsForm.controls['StuRgNo'].setValue(e.data[0]['StuRgNo']);

    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            }
            else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }
  loadsettingspageP() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(''));
          }
        }
      });

      this.mapdataaa(res.data);
    });
  }
  updatePersonalDetails() {
    this.spinner.show();
    let submitpayload = this.personalDetailsForm.value;
    let da = this.personalDetailsForm.value.StuBirthDate;
    submitpayload['StuBirthDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    submitpayload['StuPassYr'] = parseInt(this.personalDetailsForm.value.StuPassYr);
    this.umsService.updatePersonalDetails(submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
      });

  }

  checkLock() {
    this.spinner.show();
    this.route.queryParams.subscribe(
      params => {
        this.UpdateBtn = false;
        const payload = {};
        payload['UserId'] = params['UserId'];
        payload['StudentId'] = params['StudentId'];
        payload['SessionId'] = params['SessionId'];
        this.umsService.ScrutinyLock(payload).subscribe((res) => {
          if (res.status) {
            this.spinner.hide();
            let Data = res.data[0]
            if (Data.Status == 'APPR' && Data.FinalApproval == true && params['UserId'] == Data.HistoryUserId) {
              this.UpdateBtn = true;
              this.isformreadonly = true;
            }
            else {
              this.UpdateBtn = false;
            }

      } else {
        this.spinner.hide();
        this.UpdateBtn = false;
      }
    },
    );
      })
    
  }
  mapdataaa(e) {
    this.personalDetailsFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
    this.ShowPersonal = true;
  }
  ageCalculate() {
    let payload = this.personalDetailsForm.value;
    if (payload.StuBirthDate) {
      var timeDiff = Math.abs(
        Date.now() - new Date(payload.StuBirthDate).getTime()
      );
      let age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      this.personalDetailsForm.controls['StuAge'].setValue(age);
    }
  }
  fetchCountryP() {
    this.spinner.show();
    const payload = {};
    this.StateCodeListP = []
    this.filteredListStateP = []
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.PCountryCodeList = res.data;
        this.filteredListPCountryCode = this.PCountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchCountryC() {
    this.spinner.show();
    const payload = {};
    this.StateCodeListC = []
    this.filteredListStateC = []
    this.districtCodeListC = []
    this.filteredListDistrictC = []
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.filteredListStateC = []
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CCountryCodeList = res.data;
        this.CfilteredListCountryCode = this.CCountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }
  fetchStateP(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
        this.contactDetailsForm.controls["StuStateP"].setValue('');

      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateP2(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []

    payload['CountryCode'] = CountryCode;

    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateP3(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []

    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {

        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateC(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
        this.contactDetailsForm.controls["StuStateC"].setValue('');
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchStateC2(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictP(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();

        this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictP2(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }

  fetchDistrictP3(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictC(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
        this.contactDetailsForm.controls["StuDistrictC"].setValue('');
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  fetchDistrictC2(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    // payload['CountryName'] = id;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  }
  getTehasilDataC(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilCList = res.data;
      this.filteredtehasilCList = this.tehasilCList.slice();
      this.contactDetailsForm.controls["StuTehsilC"].setValue('');
    });
  }
  getTehasilDataC2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilCList = res.data;
      this.filteredtehasilCList = this.tehasilCList.slice();
    });
  }
  getTehasilDataP(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilPList = res.data;
      this.filteredtehasilPList = this.tehasilPList.slice();
      this.contactDetailsForm.controls["StuTehsilP"].setValue('');
    });
  }
  getTehasilDataP2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilPList = res.data;
      this.filteredtehasilPList = this.tehasilPList.slice();
    });
  }
  fetchMarritalStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'MarSt';

    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.marritalList = res.data;
        this.filteredmarritalstatusList = this.marritalList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchBloodGroup() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Bld';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.bloodgroupList = res.data;
        this.filteredBloodGroupList = this.bloodgroupList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  copyAddress(e) {
    if (e.checked == true) {
      this.isreadonly = true;
      let payload = this.contactDetailsForm.value.StuAddrC;
      let payload2 = this.contactDetailsForm.value.StuCountryC;
      this.fetchStateP3(payload2);
      let payload3 = this.contactDetailsForm.value.StuStateC;
      this.fetchDistrictP3(payload3)
      let payload4 = this.contactDetailsForm.value.StuDistrictC;
      let payload6 = this.contactDetailsForm.value.StuCityC;
      let payload7 = this.contactDetailsForm.value.StuPinC;
      this.contactDetailsForm.controls["StuAddrP"].setValue(payload);
      this.contactDetailsForm.controls["StuCountryP"].setValue(payload2);
      this.contactDetailsForm.controls["StuStateP"].setValue(payload3);
      this.contactDetailsForm.controls["StuDistrictP"].setValue(payload4);
      this.contactDetailsForm.controls["StuCityP"].setValue(payload6);
      this.contactDetailsForm.controls["StuPinP"].setValue(payload7);

    }
    else {
      this.isreadonly = false;
      this.contactDetailsForm.controls["StuAddrP"].setValue('');
      this.contactDetailsForm.controls["StuCountryP"].setValue('');
      this.contactDetailsForm.controls["StuStateP"].setValue('');
      this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      this.contactDetailsForm.controls["StuCityP"].setValue('');
      this.contactDetailsForm.controls["StuPinP"].setValue('');
    }
  }


  updateContaceDetails() {
    this.spinner.show();
    let payload = this.contactDetailsForm.value;
    if (this.contactDetailsForm.value.StuSameAddr == 1 || this.contactDetailsForm.value.StuSameAddr == true) {
      payload['StuAddrP'] = this.contactDetailsForm.value.StuAddrC;
      payload['StuCountryP'] = this.contactDetailsForm.value.StuCountryC;
      payload['StuStateP'] = this.contactDetailsForm.value.StuStateC;
      payload['StuDistrictP'] = this.contactDetailsForm.value.StuDistrictC;
      payload['StuCityP'] = this.contactDetailsForm.value.StuCityC;
      payload['StuPinP'] = this.contactDetailsForm.value.StuPinC;
    }
    this.umsService.updateContactDetails(payload).subscribe(res => {
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'

      // this.umsService.openSnackbar(res.message)

    },
    );
  }


  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = res.data;
      this.SessionFilterList = this.sTypeList.slice();
    },);
  }

  fetchGender() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchMotherTounge() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Lang';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.mothertoungList = res.data;
        this.filteredMotherToungList = this.mothertoungList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }


  prepopulationC() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          this.fetchStateC2(res.data[0].StuCountryC);
          this.fetchStateP2(res.data[0].StuCountryP);
          this.fetchDistrictC2(res.data[0].StuStateC);
          this.fetchDistrictP2(res.data[0].StuStateP);
          if (res.data[0].StuSameAddr == 1) {
            this.isreadonly = true;
          } else {
            this.isreadonly = false;
          }
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageC(res);
        } else {
          this.loadsettingspageC();
        }
      } else {
        this.ShowContact = false;
        this.loadsettingspageC();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowContact = false;
    })
  }

  prepopulatedatapageC(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.contactDetailsForm.controls['StuAddrId'].setValue(e.data[0]['StuAddrId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.contactDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ShowContact = true;
    });
  }

  loadsettingspageC() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(
              element.FormControlName,
              new FormControl('')
            );
          }
        }
      });
      this.contactDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }

  fetchCountry() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CountryCodeList = res.data;
        this.filteredListCountryCode = this.CountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchState() {
    this.spinner.show();
    const payload = {};
    this.umsService.getState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.StateCodeList = res.data;
        this.filteredListState = this.StateCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchDistrict() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeList = res.data;
        this.filteredListDistrict = this.districtCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchNationality() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'NL';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchDomicile() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Dm';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.domicileList = res.data;
        this.filteredDomicileList = this.domicileList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchRegion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Regio';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.regionList = res.data;
        this.filteredRegionList = this.regionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCourseLevel() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'COLVL';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchPassYear() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'PaYr';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.PassYearList = res.data;
        this.filteredPassYearList = this.PassYearList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCourseForQual() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Cours';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.courseQualList = res.data;
        this.filteredcourseList = this.courseQualList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchBoardUni() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'BOARD';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.boardUniList = res.data;
        this.filteredboardUniList = this.boardUniList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  prepopulationR() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {

          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.fetchMinorityType(res.data[0].StuMinorityType);
          this.StuMinorityTypeDisable2(res.data[0])
          this.fetchCast(res.data[0].StuConstiSubCate);
          this.prepopulatedatapageR(res);
        } else {
          this.loadsettingspageR();
        }
      } else {
        this.spinner.hide();
        this.loadsettingspageR();
        this.ShowReservation = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowReservation = false;
    })
  }

  StuMinorityTypeDisable2(e) {
    if (e.StuMinority === 2 || e.StuMinority == 2) {
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    } else {
      this.isStuMinorityTypeDisable = false
      this.isStuMinorityType2Disable = false
    }
  }

  onSelectionCastCertificat2(e) {
    if (e == '2') {
      this.isStuCasteValCertDisable = true;
      this.isStuNonCrmValDtDisable = true;
      this.isStuNonCrmValDtDisable2 = true
    }
  }

  StuOrphanTypeDisable2(e) {
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
    }
    else if (e == 2) {
      this.isStuOrphanTypeDisable = true
    }
  }

  StuSpecialAbledTypeDisable2(e) {
    if (e == 1) {
      this.isStuSpecialAbledTypeDisable = false
    }
    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
    }
  }

  fetchMinorityType2(value) {
    this.spinner.show();
    this.disableMinority = false;
    const payload = {};
    if (value === 1) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else if (value === 2) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
    else {
      this.spinner.hide()
      this.isStuMinorityType2Disable = true;
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      payload['MinorityType'] = 3;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }

  prepopulatedatapageR(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.reservationsDetailsForm.controls['StuResId'].setValue(e.data[0]['StuResId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        } else {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.reservationsDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ShowReservation = true;
    });
  }

  loadsettingspageR() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.reservationsDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }

  fetchMinorityType(value) {
    this.spinner.show();
    const payload = {};
    if (value === 1) {
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else {
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }

  fetchCast(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;
      this.spinner.show()
      const payload = {};
      this.categoryList = [];
      this.filteredCategoryList = [];
      payload['CategoryId'] = value;
      this.umsService.fetchCategory(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.categoryList = res.data;
          this.filteredCategoryList = this.categoryList.slice();
        }
        else {

        }

      });
    }


  }

  fetchCast2(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.get('StuCaste').patchValue('');
      this.reservationsDetailsForm.get('StuCasteCert').patchValue(2);
      this.reservationsDetailsForm.get('StuCasteValCert').patchValue(3);
      this.reservationsDetailsForm.get('StuNonCrmCert').patchValue(2);
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuInHouse').patchValue(2);
      this.reservationsDetailsForm.get('StuMinority').patchValue(2);
      this.reservationsDetailsForm.get('StuMinorityType').patchValue(3);
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');

      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;

    }

    this.spinner.show()
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CategoryId'] = value;
    this.umsService.fetchCategory(payload).subscribe((res) => {
      this.spinner.hide()
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      }
      else {

      }

    });
  }

  fetchReligion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Reg';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.religionList = res.data;
        this.filteredReligionList = this.religionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchSpAbled() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SpAb';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.specialAbledList = res.data;
        this.filteredspecialAbledList = this.specialAbledList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchorphanType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Op';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.orphanTypeList = res.data;
        this.filteredorphanTypeList = this.orphanTypeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchConstiCate() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchSocialReservation() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  prepopulationQ() {
    this.spinner.show();

    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {

      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageQ(res);
        } else {
          this.loadsettingspageQ();
        }
      } else {
        this.spinner.hide();
        this.ShowQualify = false;
        this.loadsettingspageQ();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowQualify = false;
    })
  }

  prepopulatedatapageQ(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e.data[0]['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName],));

        } else {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ShowQualify = true;
    });

    this.fetchQualDetailsForTable();
  }

  loadsettingspageQ() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.qualificationDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
  }

  fetchQualDetailsForTable() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    payload['StuQualId'] = '';
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.qualList = res.data;
      if (res.data.length == 0) {
        this.isDivShow = false;
      }
      else {
        this.isDivShow = true;
      }
    })
  }

  onSelectionChanged2({ value }) {
    if (value = 2) {
      this.resultNotDec = true;
      this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();
      this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
      this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
      this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
      this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
      this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
      this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();

    } else {
      this.resultNotDec = false;
    }
  }

  onselectPrepopulate(e) {
    this.spinner.show();
    this.onSelectionChanged2(e);
    this.qualificationDetailsFormArray = [];
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);

        }
        else if (element.FormVisible == false) {
          // this.qualificationDetailsForm.controls[element.FormControlName].setValue('');
        }
      }

      );
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));

    });

  }

  prepopulationA() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          this.fetchDate(res.data)
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageA(res);
        } else {
          this.loadsettingspageA();
        }
      } else {
        this.spinner.hide();
        this.ShowAddit = false;
        this.loadsettingspageA();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowAddit = false;
    })
  }

  prepopulatedatapageA(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(e.data[0]['StuExtraId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        } else {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ShowAddit = true;
    });
  }

  loadsettingspageA() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(''));

        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }


  prepopulationPS() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      this.spinner.hide();

      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          this.photoSignDetailsForm = this.fb.group({
            StuId: new FormControl(data.StuId),
            StuRgNo: new FormControl(data.StuRgNo),
            StuPhoto: new FormControl(data.StuPhoto),
            StuSignature: new FormControl(data.StuSignature),
          });
          this.userImage = res.data[0].StuPhoto
          this.signatureImage = res.data[0].StuSignature
        }
        this.ShowPhoto = true;
      } else {
        this.ShowPhoto = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowPhoto = false;
    })
  }

  fetchDate(item) {
    if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }

  prepopulationAD() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.getFeeTempData(res.data[0].SessionId, res.data[0].StuCoId, res.data[0].StuCgId, res.data[0].StuId)
        this.GetTranscript(res.data[0].StuId)
        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        this.getExamForLateral(res.data[0].StuEmId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",")
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          sessionStorage.setItem("StuAcadId", res.data[0].StuAcadId);

          this.getCourseData(res.data[0].StuFacId);
          this.getExamStreamData(res.data[0].StuCoId, res.data[0].StuBrId);
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');
          dataArray.forEach(item => {
            const splitValues = item.split('-');
            const obj = {
              Code: splitValues[0],
              Id: splitValues[1]
            };
            this.newSelectedValues.push(obj);
          });
          this.prepopulatedatapageAD(res);

        } else {
          this.showchat = true;
          this.loadsettingspageAD();
        }
      }
      else {
        this.spinner.hide();
        this.ShowAdmission = false;
        this.loadsettingspageAD();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowAdmission = false;
    })
  }

  getExamForLateral(id) {
    const payload2 = {};
    payload2['EmId'] = id;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
    });
  }
  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);
  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
  }

  getBrId(id) {
    this.BranchId = id;
  }

  getSubData(id) {
    this.spinner.show()
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.BranchId;
    this.umsService.fetchSubs(payload).subscribe(res => {
      this.spinner.hide()
      this.ErrorMessage = '';
      this.SubError = false;
      this.Subjects = [];
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.MinMax = false;
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      // this.getExamSubMapFetch(id)
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
    });
  }

  prepopulatedatapageAD(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';

    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        }
        else {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ShowAdmission = true;
    });

  }
  loadsettingspageAD() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.admissionDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
  }

  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      this.spinner.hide();
      this.facultyList = res.data;
      this.filteredFacultyList = this.facultyList.slice();
    });
  }

  fetchStudyMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.studyModeList = res.data;
        this.filteredstudyModeList = this.studyModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchStudentType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  onCheckbox(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    this.validateCheckboxesForItem();
  }

  validateCheckboxesForItem(): void {
    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );

      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes: any[]): void {
    const totalSelected = selectedCheckboxes.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[item.OpCode] = `Selected checkboxes should be between ${opMin} and ${opMax}`;
    } else {
      delete this.validationErrors[item.OpCode];
    }
  }


  getCourseData(id) {
    this.spinner.show();
    const payload = {};
    payload['CoFcCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
    });
  }

  getExamStreamData(id, StrId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length > 0) {
        res.data.forEach(element => {

        });

        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.showchat = true;
      } else {
        this.showchat = true;
      }

    },
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
      this.examList = res.data;
      this.filteredExamList = this.examList.slice();
    });

    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.courseClg(payload3).subscribe(res => {
      this.spinner.hide();
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
    });

  }

  fetchDocument() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.ducumentList = res.data;
      if (res.data.length == 0) {
        this.isDivShow = false;
        this.ShowDoc = false;
      }
      else {
        this.isDivShow = true;
        this.ShowDoc = true;
      }
      //sessionStorage.setItem("StuDocId",res.data[0].StuDocId);

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowDoc = false
    });
  }

  fetchForupdate(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = data.StuId;
    payload['StuDocId'] = data.StuDocId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      let data = res.data[0];


      sessionStorage.setItem('StuDocId', data.StuDocId)
      if (res.status) {
        let StuRemarkCheck = false;
        if (data.StuRemarkCheck == 1) {
          StuRemarkCheck = true;
        } else {
          StuRemarkCheck = false;
        }
        // const creds = this.documentDetailsForm.controls.arrData as FormArray;
        this.documentDetailsForm = this.fb.group({
          arrData: this.fb.array([]),
          StuId: new FormControl(data.StuId),
          StuSrNo: new FormControl(data.StuSrNo, [Validators.required]),
          StuDocumentName: new FormControl(data.StuDocumentName, Validators.required),
          StuRemark: new FormControl(data.StuRemark, Validators.required),
          StuFileUpload: new FormControl(data.StuFileUpload),
          StuRemarkConfirm: new FormControl(data.StuRemarkConfirm),
          StuRemarkCheck: new FormControl(StuRemarkCheck),
        });
        let preArr = [];
        const tmpDict = {};
        tmpDict['StuId'] = new FormControl(data.StuId);
        tmpDict['StuSrNo'] = new FormControl(data.StuSrNo, [Validators.required]);
        tmpDict['StuDocumentName'] = new FormControl(data.StuDocumentName),
          tmpDict['StuRemark'] = new FormControl(data.StuRemark);
        tmpDict['StuFileUpload'] = new FormControl(data.StuFileUpload);
        tmpDict['StuRemarkConfirm'] = new FormControl(data.StuRemarkConfirm);
        tmpDict['StuRemarkCheck'] = new FormControl(data.StuRemarkCheck);
        const creds = this.documentDetailsForm.controls.arrData as FormArray;
        creds.push(new FormGroup(tmpDict));
      } else {
      }

    });

  }

  showbase64(e) {
    console.log('hhhhhhhhhhhhhhhhh',e);
    const dialogRef3 = this.dialog.open(PdfViewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.fileUploadData
      });
  }

  showbase642(e) {
    const dialogRef3 = this.dialog.open(PdfViewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.StuFileUpload
      });
  }

  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = BranchId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      this.spinner.hide();
      this.SubjectData = res.data.children;
      this.SubjectData.forEach(element => {
        if (element.EsType == 'S') {
          this.Subs = true;
          if (this.Subjects.indexOf(element.EsCode) === -1) {
            this.Subjects.push(element.EsCode);
            this.SubjectName.push(element.EsName);
            this.Sub.push(element.EsOpCode)
            this.AllSub.push(element)
            if (element.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
          }
          if (element.EsOpCode == " " && element.EsType == 'S') {
            const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.selectedCheckboxes.push(element);
            }
          }
          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }
          })
        }
        else if (element.EsType == 'G') {
          this.OptSub = true;
          if (element.EsOpCode !== ' ') {
            const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
            if (!DupOpt) {
              this.selectedOptions.push(element.EsOpCode);
            }
          }
          const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
          if (!isDuplicate) {
            this.GroupData.push(element);
          }
          element.children.forEach(element1 => {
            if (element1.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element1.EsOpCode);
              }
            }

            if (element1.EsOpCode == " ") {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element1);
              }
            }

            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }

              }

            })
          });

          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsId) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }

          })
          for (const value of this.newSelectedValues) {
            element.children.forEach(element2 => {
              if (element2.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element2.EsOpCode);
                }
              }
            });
          }

        }
      });
      await this.getOptionData(EmId, BranchId);
    });


  }


  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = BranchId;
    this.umsService.getOption(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status == true) {
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.MinMax = false;
      }
    });
  }


  onSelectionCastCertificat(e) {
    if (e === '1') {
      this.isStuCasteValCertDisable = false
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue('')
    } else {
      this.isStuCasteValCertDisable = true
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue(2)
    }
  }

  StuNonCrmValDtDisable(e) {
    if (e === '1' || e === 1) {
      this.isStuNonCrmValDtDisable = false
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue(2)
    } else {
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.isStuNonCrmValDtDisable = true
    }
  }

  StuOrphanTypeDisable(e) {
    this.isStuOrphanTypeDisable = false
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('')
    } else {
      this.isStuOrphanTypeDisable = true
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('NA')
    }
  }



  StuSpecialAbledTypeDisable(e) {
    this.isStuSpecialAbledTypeDisable = false
    if (e == 1) {

      this.isStuSpecialAbledTypeDisable = false
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('')
    }

    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('NA')

    }
  }



  StuMinorityTypeDisable(e) {
    if (e === 1) {
      this.isStuMinorityTypeDisable = false
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue('')
      this.isStuMinorityType2Disable = false
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue('')
    } else {
      this.isStuMinorityTypeDisable = true
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue(3)
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)

    }
  }

  getRegData(data) {
    const payload = {}
    payload['RgNo'] = data['StuRgNo']
    this.umsService.SearchRegn(payload).subscribe((res) => {
      // this.ExamData(res.data[0])
      this.getData(res.data[0])
    })
  }


  fetchCertStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CertS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.CertList = res.data;
        this.filteredCertList = this.CertList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  Save() {

    if (this.CertScrutinyForm.invalid) {

      // this.CertScrutinyForm.controls['FileUpload'].markAsTouched();
      // if (this.ProvisionalData[0].HardCopy == true) {
      //   this.CertScrutinyForm.controls['FileUpload'].markAsTouched();
      // }else{
      //   this.CertScrutinyForm.controls['FileUpload'].setErrors(null);
      //     this.CertScrutinyForm.controls['FileUpload'].clearValidators();
      //     this.CertScrutinyForm.controls['FileUpload'].updateValueAndValidity();
      //     this.CertScrutinyForm.get('FileUpload').markAsUntouched();
      // }
      if ((this.Tclcdata['CertStatus'] == 'APPAP') && (this.uploadDoc != undefined || this.uploadDoc != '')) {
        this.SubmitHardCopy();
      }
      else {
        this.CertScrutinyForm.get('CertStatus').markAsTouched();
      }
    }
    else {
      this.Submit()
    }
  }

  Submit() {

    if (this.CertScrutinyForm.value['CertStatus'] === 'APPAP') {
      if (this.Tclcdata['CertType'] === 'ADMC' && this.AdmFeesPaid === true) {
        this.SubmitScrutiny()
      }
      else if (this.Tclcdata['CertType'] === 'ADMC' && this.AdmFeesPaid == false) {
        let data = {}
        data['message'] = 'Admission Fees Not Paid!'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      else if (this.Tclcdata['CertType'] === 'TC' || this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'TS') {
        if (this.Tclcdata['FeeStatus'] === 'Y' && (this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'TS')) {
          let data = {}
          data['message'] = 'Application Already Approved'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
        else if (this.Tclcdata['FeeStatus'] === 'Y' && this.Tclcdata['CertType'] === 'TC') {
          if (this.userPermission[0].CgUi == 'C') {
            if (this.userPermission[0].CgId == this.Tclcdata['StuCollege']) {
              if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "APR" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
                // this.SubmitScrutiny()
                let data = {}
                data['message'] = 'Application Already Approved'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              }
              else if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
                let data = {}
                data['message'] = 'Application Still Not Approved By Destination College'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              }
              else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
                let data = {}
                data['message'] = 'Application Rejected By Destination College'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              }
            }
            else if (this.userPermission[0].CgId == this.Tclcdata['DestClg']) {
              if (this.Tclcdata['CertStatus'] == "APR") {
                let data = {}
                data['message'] = 'Already Certificate Generated'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              } else {
                this.SubmitScrutiny()
              }

            }

          }
          else {
            if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
              let data = {}
              data['message'] = 'Application Still Not Approved By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
              let data = {}
              data['message'] = 'Application Rejected By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "APPAP") {

              this.SubmitScrutiny()
            }
            else {
              this.SubmitScrutiny()
            }

          }
        }
        else if (this.Tclcdata['FeeStatus'] != 'Y' && (this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'TC')) {
          this.SubmitScrutiny()
        }
        else {
          this.SubmitScrutiny()
        }




      }
      else if ((this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'PC' || this.Tclcdata['CertType'] === 'OPC') && (this.Tclcdata['FeeStatus'] == 'Y')) {
        this.SubmitScrutiny()
      }
      else if (this.Tclcdata['CertType'] === 'RC' && (this.Tclcdata['FeeStatus'] == 'Y')) {

        const totStudent = this.CertScrutinyForm.value['totStudent'];
        const rank = this.CertScrutinyForm.value['rank'];

        if (!totStudent && !rank) {
          this.CertScrutinyForm.get('totStudent').setValidators([Validators.required]);
          this.CertScrutinyForm.get('totStudent').updateValueAndValidity();
          this.CertScrutinyForm.get('totStudent').markAsTouched();
          this.CertScrutinyForm.get('rank').setValidators([Validators.required]);
          this.CertScrutinyForm.get('rank').updateValueAndValidity();
          this.CertScrutinyForm.get('rank').markAsTouched();
        } else if (!totStudent) {
          this.CertScrutinyForm.get('totStudent').setValidators([Validators.required]);
          this.CertScrutinyForm.get('totStudent').updateValueAndValidity();
          this.CertScrutinyForm.get('totStudent').markAsTouched();
          this.CertScrutinyForm.get('rank').clearValidators();
          this.CertScrutinyForm.get('rank').updateValueAndValidity();
        } else if (!rank) {
          this.CertScrutinyForm.get('totStudent').clearValidators();
          this.CertScrutinyForm.get('totStudent').updateValueAndValidity();
          this.CertScrutinyForm.get('rank').setValidators([Validators.required]);
          this.CertScrutinyForm.get('rank').updateValueAndValidity();
          this.CertScrutinyForm.get('rank').markAsTouched();
        } else {
          this.UpdateRank();
        }

      }
    }
    else if (this.CertScrutinyForm.value['CertStatus'] === 'APR') {
      if ((this.Tclcdata['CertType'] === 'TC' || this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'TS') && this.Tclcdata['FeeStatus'] != 'Y') {
        let data = {}
        data['message'] = 'Application Fees Not Paid!'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      else if ((this.Tclcdata['CertType'] === 'TC') && this.Tclcdata['FeeStatus'] === 'Y') {
        if (this.userPermission[0].CgUi == 'C') {
          if (this.userPermission[0].CgId == this.Tclcdata['StuCollege']) {
            if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "APR")) {
              this.SubmitScrutiny()
            }
            else if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
              let data = {}
              data['message'] = 'Application Still Not Approved By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
              let data = {}
              data['message'] = 'Application Rejected By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
          }
          else if (this.userPermission[0].CgId == this.Tclcdata['DestClg']) {
            let data = {}
            data['message'] = 'You Cannot Generate Certificate. You Can Approve Or Reject Only'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.SubmitScrutiny()
          }

        }
        else {
          if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
            let data = {}
            data['message'] = 'Application Still Not Approved By Destination College'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
          else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
            let data = {}
            data['message'] = 'Application Rejected By Destination College'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
          else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "APPAP") {

            this.SubmitScrutiny()
          }
          else {
            this.SubmitScrutiny()
          }

        }
      }
      else {
        this.SubmitScrutiny()
      }
    }
    else if (this.CertScrutinyForm.value['CertStatus'] === 'REC') {
      this.CertScrutinyForm.get('rank').clearValidators();
      this.CertScrutinyForm.get('rank').updateValueAndValidity();
      this.CertScrutinyForm.get('totStudent').clearValidators();
      this.CertScrutinyForm.get('totStudent').updateValueAndValidity();
      if (this.Tclcdata['CertType'] === 'PC' || this.Tclcdata['CertType'] === 'OPC' || this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'RC') {
        if (this.Tclcdata['CertStatus'] == "APPAP") {
          let data = {}
          data['message'] = 'Certificate Already Generated'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
        else {
          this.SubmitScrutiny()
        }
      }
      else {
        this.SubmitScrutiny()
      }
    }
    else if (this.CertScrutinyForm.value['CertStatus'] === 'REJ') {
      this.CertScrutinyForm.get('rank').clearValidators();
      this.CertScrutinyForm.get('rank').updateValueAndValidity();
      this.CertScrutinyForm.get('totStudent').clearValidators();
      this.CertScrutinyForm.get('totStudent').updateValueAndValidity();
      if (this.Tclcdata['CertType'] === 'TS') {
        if (this.Tclcdata['FeeStatus'] === 'Y') {
          // let data = {}
          // data['message'] = 'Application Fees Already Paid, Cannot Reject Now'
          // data['title'] = 'Information'
          // data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.SubmitScrutiny()
        }
        else {
          this.SubmitScrutiny()
        }

      }
      else if (this.Tclcdata['CertType'] === 'PC' || this.Tclcdata['CertType'] === 'OPC' || this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'RC') {
        if (this.Tclcdata['CertStatus'] == "APPAP") {
          let data = {}
          data['message'] = 'Certificate Already Generated'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
        else {
          this.SubmitScrutiny()
        }
      }
      else {
        if (this.Tclcdata['FeeStatus'] === 'Y') {

          if (this.userPermission[0].CgUi == 'C') {
            if (this.userPermission[0].CgId == this.Tclcdata['DestClg']) {
              if (this.Tclcdata['CertStatus'] == "APR") {
                let data = {}
                data['message'] = 'Already Certificate Generated'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              } else {
                this.SubmitScrutiny()
              }
              // this.SubmitScrutiny()
            }

            else {
              let data = {}
              data['message'] = 'Application Fees Already Paid, Cannot Reject Now'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
          }
          else {
            let data = {}
            data['message'] = 'Application Fees Already Paid, Cannot Reject Now'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }

        }
        else {
          this.SubmitScrutiny()
        }
      }

    }

    else {
      this.SubmitScrutiny()
    }
  }

  SubmitHardCopy() {
    this.spinner.show()

    if (this.uploadDoc == undefined || this.uploadDoc == '') {
      this.Copy = 'Soft'
    }
    else if (this.uploadDoc != undefined || this.uploadDoc != '') {
      this.Copy = 'Hard'
    }
    let type = '';
    switch (this.Tclcdata['CertType']) {
      case "MC":
        type = 'Migration'
        break;
      case "PC":
        type = "Provisional Passing"
        break;
      case "OPC":
        type = "Original Passing"
        break;
      case "RC":
        type = "Rank"
        break;
      default:
        type = this.Tclcdata['CertType'];
        break;
    }
    const payload = {}
    let submitpayload = this.CertScrutinyForm.value
    payload['StuFaculty'] = this.Tclcdata['StuFaculty'],
      payload['StuCourse'] = this.Tclcdata['StuCourse'],
      payload['StuCollege'] = this.Tclcdata['StuCollege'],
      payload['StuExam'] = this.Tclcdata['StuExam'],
      payload['StuBranch'] = this.Tclcdata['StuBranch'],
      payload['SnNo'] = this.Tclcdata['SnNo'],
      payload['CertType'] = this.Tclcdata['CertType'],
      payload['DestClg'] = this.Tclcdata['DestClg'],
      payload['Reason'] = this.Tclcdata['Reason'],
      payload['FeeStatus'] = this.Tclcdata['FeeStatus'],
      payload['CertStatus'] = 'APPAP';
    payload['StuId'] = this.Tclcdata['StuId'],
      payload['TclcId'] = this.Tclcdata['TclcId'],
      payload['Comment'] = submitpayload['Comment'],
      payload['CertScr'] = 'APPAP',
      payload['StatusBy'] = sessionStorage.getItem('userId')
    payload['FileUpload'] = this.ProvisionalData[0]['FileUpload'] ? this.ProvisionalData[0]['FileUpload'] : this.uploadDoc;;
    payload['StuEmail'] = this.ProvisionalData[0]['EmailId'];
    payload['Copy'] = this.Copy;
    payload['Certificate'] = type;
    this.umsService.setTclcData(payload)
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if (res.status) {

        if (this.Tclcdata['CertType'] == 'RC') {
          const payload2 = {}
          let submitpayload = this.CertScrutinyForm.value
          payload2['StuName'] = this.Tclcdata['StuName'],
            payload2['StuPRN'] = this.Tclcdata['StuPRN'],
            payload2['StuAdd'] = this.ProvisionalData[0]['StuAdd'],
            payload2['StuPhone'] = this.ProvisionalData[0]['StuPhone'],
            payload2['StuFatherName'] = this.ProvisionalData[0]['StuFatherName'],
            payload2['StuMotherName'] = this.ProvisionalData[0]['StuMotherName'],
            payload2['LastInst'] = this.ProvisionalData[0]['LastInst'],
            payload2['LastRollNo'] = this.ProvisionalData[0]['LastRollNo'],
            payload2['LastExam'] = this.ProvisionalData[0]['LastExam'],
            payload2['CoCode'] = this.ProvisionalData[0]['CoCode'],
            payload2['EmailId'] = this.ProvisionalData[0]['EmailId'],
            payload2['EmMonth'] = this.ProvisionalData[0]['EmMonth'],
            payload2['regnYear'] = this.ProvisionalData[0]['regnYear'],
            payload2['HardCopy'] = this.ProvisionalData[0]['HardCopy'],
            payload2['EmDate'] = this.ProvisionalData[0]['EmDate'],
            payload2['StuFaculty'] = this.Tclcdata['StuFaculty'],
            payload2['StuCourse'] = this.Tclcdata['StuCourse'],
            payload2['StuCollege'] = this.Tclcdata['StuCollege'],
            payload2['StuExam'] = this.Tclcdata['StuExam'],
            payload2['StuBranch'] = this.Tclcdata['StuBranch'],
            payload2['SnNo'] = this.Tclcdata['SnNo'],
            payload2['CertType'] = this.Tclcdata['CertType'],
            payload2['DestClg'] = this.Tclcdata['DestClg'],
            payload2['Reason'] = this.Tclcdata['Reason'],
            payload2['FeeStatus'] = this.Tclcdata['FeeStatus'],
            payload2['CertStatus'] = submitpayload['CertStatus'];
          payload2['StuId'] = this.Tclcdata['StuId'],
            payload2['TclcId'] = this.Tclcdata['TclcId'],
            payload2['Comment'] = submitpayload['Comment'],
            payload2['CertScr'] = submitpayload['CertStatus'],
            payload2['StuRank'] = submitpayload['rank'],
            payload2['TotalCandidate'] = submitpayload['totStudent'],
            payload2['StatusBy'] = sessionStorage.getItem('userId')
          payload2['RankId'] = this.ProvisionalData[0].RankId


          this.umsService.UpdateRank(payload2).subscribe((res) => {
            this.spinner.hide()
            let data = {}
            data['message'] = "Submitted Successfully"
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.dialogRef.afterClosed().subscribe(result => {



              // this.tclc.push(payload)
              this.Tclcdata['CertStatus'] = submitpayload['CertStatus']
              // if(this.Tclcdata['CertType'] == 'RC' && submitpayload['CertStatus'] == 'APPAP'){
              //   this.UpdateRank();
              // }
              this.ngOnInit()
              this.getScrData();
              this.SaveDisabled = true
              this.showReport = true
            })
          })
        }
        else {
          this.spinner.hide()
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.tclc = []
            // this.tclc.push(payload)
            this.umsService.setTclcData(payload)
            this.Tclcdata['CertStatus'] = submitpayload['CertStatus']
            // if(this.Tclcdata['CertType'] == 'RC' && submitpayload['CertStatus'] == 'APPAP'){
            //   this.UpdateRank();
            // }
            this.ngOnInit()
            this.getScrData();
            this.SaveDisabled = true
            this.showReport = true
          })
        }

      } else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.tclc = []
          this.tclc.push(payload)
          this.Tclcdata['CertStatus'] = submitpayload['CertStatus']
          // if(this.Tclcdata['CertType'] == 'RC' && submitpayload['CertStatus'] == 'APPAP'){
          //   this.UpdateRank();
          // }
          this.ngOnInit()
          this.getScrData();
        })
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  SubmitScrutiny() {
    this.spinner.show()
    if (this.uploadDoc == undefined || this.uploadDoc == '') {
      this.Copy = 'Soft'
    }
    else if (this.uploadDoc != undefined || this.uploadDoc != '') {
      this.Copy = 'Hard'
    }
    let type = '';
    switch (this.Tclcdata['CertType']) {
      case "MC":
        type = 'Migration'
        break;
      case "PC":
        type = "Provisional Passing"
        break;
      case "OPC":
        type = "Original Passing"
        break;
      case "RC":
        type = "Rank"
        break;
      default:
        type = this.Tclcdata['CertType'];
        break;
    }
    const payload = {}
    let submitpayload = this.CertScrutinyForm.value
    payload['StuFaculty'] = this.Tclcdata['StuFaculty'],
      payload['StuCourse'] = this.Tclcdata['StuCourse'],
      payload['StuCollege'] = this.Tclcdata['StuCollege'],
      payload['StuExam'] = this.Tclcdata['StuExam'],
      payload['StuBranch'] = this.Tclcdata['StuBranch'],
      payload['SnNo'] = this.Tclcdata['SnNo'],
      payload['CertType'] = this.Tclcdata['CertType'],
      payload['DestClg'] = this.Tclcdata['DestClg'],
      payload['Reason'] = this.Tclcdata['Reason'],
      payload['FeeStatus'] = this.Tclcdata['FeeStatus'],
      payload['CertStatus'] = submitpayload['CertStatus'];
    payload['StuId'] = this.Tclcdata['StuId'],
      payload['TclcId'] = this.Tclcdata['TclcId'],
      payload['Comment'] = submitpayload['Comment'],
      payload['CertScr'] = submitpayload['CertStatus'],
      payload['StatusBy'] = sessionStorage.getItem('userId')
    payload['FileUpload'] = this.ProvisionalData[0]['FileUpload'] ? this.ProvisionalData[0]['FileUpload'] : this.uploadDoc;
    payload['StuEmail'] = this.ProvisionalData[0]['EmailId'];
    payload['Copy'] = this.Copy;
    payload['Certificate'] = type;

    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()

        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.tclc = []
          this.tclc.push(payload)
          this.Tclcdata['CertStatus'] = submitpayload['CertStatus']
          // if(this.Tclcdata['CertType'] == 'RC' && submitpayload['CertStatus'] == 'APPAP'){
          //   this.UpdateRank();
          // }
          this.ngOnInit()
          this.getScrData();
          this.SaveDisabled = true
          this.showReport = true
        })
      } else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.Tclcdata['CertStatus'] = submitpayload['CertStatus']
          this.ngOnInit()
          this.getScrData()
        })
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getScrData() {
    const payload = {}
    payload['CertType'] = this.Tclcdata['CertType']
    payload['StuId'] = this.Tclcdata['StuId']
    this.umsService.GetCertScr(payload).subscribe((res) => {
      if (res.status) {
        this.CertScrId = res.data[0]['CertScr_Id'];

        this.spinner.hide()

      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getTclc() {
    const payload = {};
    payload['SessionId'] = this.Tclcdata['SnNo'];
    payload['CertType'] = this.Tclcdata['CertType'];
    payload['IsStudent'] = 0
    payload['StuId'] = this.Tclcdata['StuId']
    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status) {
        // this.Tclcdata = res.data.filter(record => record.StuId == this.Tclcdata['StuId']);
        this.Tclcdata = res.data

      }
    })

  }

  isOptionDisabled(item) {
    if (this.Tclcdata['CertType'] === 'ADMC') {
      const App = 'APR';
      const Status = 'REJ';
      return item === App || item === Status;
    }
    else if (this.Tclcdata['CertType'] === 'TS') {
      const App = 'APPAP';
      return item === App
    }
    else if (this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'RC' || this.Tclcdata['CertType'] === 'PC' || this.Tclcdata['CertType'] === 'OPC') {
      const App = 'APR';
      const Status = 'UFD';
      const Reject = 'REJ';
      return item === App || item === Status || item === Reject;
    }
    else {
      if (this.userPermission[0].CgUi == 'C') {
        if (this.Tclcdata['DestClg'] == this.userPermission[0].CgId) {
          const App = 'APR';
          return item === App
        }
      }
      else {
        return false
      }
    }
  }

  getFeeTempData(SnNo, CoCode, CgCode, StuId) {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = SnNo,
      payload['CoCode'] = CoCode;
    payload['CgCode'] = CgCode;
    payload['StuId'] = StuId;
    payload['FeeType'] = 'AF';
    this.umsService.SearchFeeAdm(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.AdmFee(res.data[0].TemplateCode, SnNo, StuId)

      } else {
        this.AdmFeesPaid = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.AdmFeesPaid = false
    });
  }

  AdmFee(TemplateCode, SnNo, StuId) {
    const payload = {};
    payload['FeeTemplateCode'] = TemplateCode;
    payload['StuId'] = StuId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = SnNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const totalFeeAmount = res.data.reduce((sum, item) => sum + item.FeeAmount, 0);
        if (res.data[0].TotalPaidAmount === totalFeeAmount) {
          this.AdmFeesPaid = true
          this.FeesData = res.data
        }
        else {
          this.AdmFeesPaid = false
        }

      } else {
        this.AdmFeesPaid = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.AdmFeesPaid = false
    });

  }

  History() {
    let data = {};
    data['CertType'] = this.Tclcdata['CertType'];
    data['StuId'] = this.Tclcdata['StuId']
    this.dialogRef1 = this.dialog.open(TclcHistoryComponent, {
      disableClose: true,
      width: "900px",
      height: "600px",
      data,
    });
    this.dialogRef1.afterClosed().subscribe((result) => {
      // this.ngOnInit();
    });
  }


  GetTranscript(StuId) {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = StuId
    this.umsService.SearchTranscript(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.TranscriptData = res.data
        this.Transcript = true

      }
      else {
        this.spinner.hide()
        this.Transcript = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getTclcDocs(StuId) {
    let payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = this.Tclcdata['CertType'],
      payload['StuId'] = this.Tclcdata['StuId']
    this.umsService.GetTcLcDocDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          this.TclcDocData = res.data.filter(record => record.StuId == StuId);
          if (this.TclcDocData.length > 0) {

          this.TclcDoc = true;
          this.TclcDocData.forEach((item: any) => {
            item.isViewable = false;
            if (!item.FileUpload) {
              return;
            }
            this.umsService.fetchDocument({
              filePath: item.FileUpload,
              viewFile: true
            }).subscribe(
              (docRes: any) => {
                item.isViewable = docRes.isViewable;
              },
              (error) => {
                console.error('Document error:', error);
                item.isViewable = false;
              }
            );
          });
        } else {
          this.TclcDoc = false;
        }
      } else {
        this.TclcDoc = false;
      }
      })
  }

showbase643(e: any) {
  const data = e;
   sessionStorage.removeItem('filePath');
  sessionStorage.removeItem('pdfData')
   if (!data || data === 'null' || data === 'undefined' || data.trim() === '') {
            let data = {}
        data['message'] = 'Document not submitted.';
        data['title'] = 'Information'
        data['icon'] = 'fas fa-info-circle'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
        })
    return;
  }  else {

         sessionStorage.setItem('filePath', data)
        window.open('/pdf-viewer', '_blank');
      }
  }
 // sessionStorage.setItem('pdfData', data);
 // window.open('/pdf-viewer', '_blank');


  selectedRequest(data) {

    // if(this.tclc[0]['CertStatus'] == data){
    //   if(this.tclc[0]['CertStatus'] == 'APPAP'){
    //     this.SaveDisabled = true
    //   }else{
    //     this.SaveDisabled = false
    //   }

    // }
    // else{
    //   this.SaveDisabled = true
    // }
    if (data === 'APPAP' && this.HardCopy == true) {

      this.ishardcopy = true
    }
    else if (data === 'APPAP' && this.HardCopy == false) {
      this.ishardcopy = false
    }
    else {
      this.ishardcopy = false;
    }
    if (this.tclc?.length > 0 && (this.tclc[0]['CertStatus'] === data || this.tclc[0]['CertStatus'] === "APPAP")) {
      this.SaveDisabled = true;
    }
    else {
      this.SaveDisabled = false;
    }
  }

  getData(data) {
    this.spinner.show();
    const payload = {}
    payload['ShId'] = '',
      payload['EfCate'] = '',
      payload['CgCode'] = '',
      payload['Cent'] = '',
      payload['RollNo'] = '',
      payload['RgName'] = '',
      payload['Sex'] = '',
      payload['StrCode'] = '',
      payload['PassFail'] = '',
      payload['EfStatus'] = '',
      payload['EfBatch'] = '',
      payload['WH'] = '',
      payload['Inc'] = '',
      payload['Decl'] = '',
      payload['EfPCFr'] = '',
      payload['EfPCTo'] = '',
      payload['RgNo'] = data.RgNo
    this.umsService.searchExmList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {

        // Find the exam with the highest EfShId
        const maxEfShIdExam = res.data.reduce((max, exam) => (exam.EfShId > max.EfShId ? exam : max), res.data[0]);

        // Set examData with the single object with the greatest EfShId and initialize subjects
        this.examData = [{ ...maxEfShIdExam, subjects: [] }];

        // Fetch subjects for this exam
        this.SubData(maxEfShIdExam);


      } else {
      }


    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  SubData(exam) {

    this.spinner.show();
    const payload = {};
    payload['FsEfId'] = exam.EfId
    this.umsService.SearchExamSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {

        // Update the subjects array for the single exam in examData
        this.examData[0].subjects = res.data;


      } else {

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getProvisional(StuId) {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId
    this.umsService.getProvisional(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.courseCode = res.data[0]['CoCode']
        this.InternDate = res.data[0]['InternDate']
        this.Specialization = res.data[0]['Specialization']
        this.getProvisionalCourses(res.data[0]['CoCode'])
        this.ProvisionalData = res.data
        this.Provisional = true;
        this.HardCopy = res.data[0].HardCopy
        this.getCertificateCourses(this.courseCode)
      }
      else {
        this.spinner.hide();
        this.ProvisionalData = [];
        this.Provisional = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getPassing(StuId) {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId
    this.umsService.getPassing(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.courseCode = res.data[0]['CoCode']
         this.InternDate = res.data[0]['InternDate']
        this.Specialization = res.data[0]['Specialization']
        this.getProvisionalCourses(res.data[0]['CoCode'])
        this.ProvisionalData = res.data
        this.Provisional = true;
        this.HardCopy = res.data[0].HardCopy
        this.getCertificateCourses(this.courseCode)
      }
      else {
        this.spinner.hide();
        this.ProvisionalData = [];
        this.Provisional = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getMigration(StuId) {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId
    console.log('payload', payload);
    this.umsService.getMigration(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        console.log('data i get', res.data);
        this.courseCode = res.data[0]['CoCode']
        this.getProvisionalCourses(res.data[0]['CoCode'])
        this.ProvisionalData = res.data
        this.Provisional = true;
        this.HardCopy = res.data[0].HardCopy
        this.getCertificateCourses(this.courseCode)
      }
      else {
        this.spinner.hide();
        this.ProvisionalData = [];
        this.Provisional = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getRank(StuId) {
    console.log('get Rank api is called', StuId);

    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId
    console.log('payload', payload);

    this.umsService.getRank(payload).subscribe((res) => {
      console.log('rank data i get is', res.data);

      if (res.status) {
        this.spinner.hide();
        console.log('data i get', res.data);
        this.courseCode = res.data[0]['CoCode']
        this.getProvisionalCourses(res.data[0]['CoCode'])
        this.ProvisionalData = res.data
        this.Provisional = true;
        this.RankData = true
        this.HardCopy = res.data[0].HardCopy
        if (this.ProvisionalData[0]['StuRank'] && this.ProvisionalData[0]['TotalCandidate']) {
          this.CertScrutinyForm.controls['rank'].setValue(this.ProvisionalData[0]['StuRank'])
          this.CertScrutinyForm.controls['totStudent'].setValue(this.ProvisionalData[0]['TotalCandidate'])
        }
        this.getCertificateCourses(this.courseCode)
      }
      else {
        this.spinner.hide();
        this.ProvisionalData = [];
        this.Provisional = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getProvisionalCourses(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'PrCo';

    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let Course = []
        Course = res.data.filter((item) => item.CdCode === CoCode)
        res.data.forEach(element => {
          if (element.CdCode === CoCode) {
            this.ProvisionalCourse = element.CdDesc
            this.Provisional = true;

          }
        });
      }
      else {
        this.spinner.hide();
        this.ProvisionalCourse = ''
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ProvisionalCourse = ''
    })
  }

  getRequest(tclc: any): string {
    let type = '';

    switch (tclc['CertType']) {
      case "MC":
        type = 'Migration Certificate'
        break;
      case "TC":
        type = "Transfer Certificate"
        break;
      case "LC":
        type = "Leaving Certificate"
        break;
      case "ADMC":
        type = "Admission Cancellation"
        break;
      case "TS":
        type = "Transcript Certificate"
        break;
      case "PC":
        type = "Provisional Passing Certificate"
        break;
      case "OPC":
        type = "Original Passing Certificate"
        break;
      case "RC":
        type = "Rank Certificate"
        break;
      default:
        type = tclc['CertType'];
        break;
    }

    return type;
  }


  onChange($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    this.filename = '';  // Clear the filename
    this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;

    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  // getSortSequence(coCode: string | null | undefined): number {
  //   const certTypeSortMap: { [key: string]: number } = {
  //     'BDS': 1,
  //     'BAMS': 2,
  //     'BSN': 3,
  //     'PBBSN': 4,
  //     'BHMS': 5,
  //     'BOPTOM': 6,
  //     'MBBS': 7,
  //     'DFW': 8,
  //     'DIP': 9,
  //     'PGDDM': 10,
  //     'MSA': 11
  //   };

  //   return certTypeSortMap[coCode ?? ''] ?? 0;
  // }

  getCertificateCourses(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CourseCode'] = CoCode;

    this.umsService.getCertCourse(payload).subscribe((res) => {
      if (res.status) {
        console.log(res,'res');
        this.sortSequence = res.data[0].SortSequence
        this.ReportCoCode = res.data[0].ReportCoCode
      }
    })
  }

  Print() {
    if (this.Tclcdata['CertType'] == 'RC') {
      let qrPayload = { 
      Stuid: this.Tclcdata['StuId'], 
      CertType: this.Tclcdata['CertType'],
       LoginId: parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        InstNo: this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.Tclcdata['StuId'],
        CertType: this.Tclcdata['CertType'],
        qrUrl: res.url
      };
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        "RptCode": 304,
        "InstName": '',
        "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
        });
    }
    else if (this.Tclcdata['CertType'] == 'PC') {
     var filter: any;
    let qrPayload = { 
      Stuid: this.Tclcdata['StuId'], 
      CertType: this.Tclcdata['CertType'],
       LoginId: parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        InstNo: this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode,
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.Tclcdata['StuId'],
        CertType: this.Tclcdata['CertType'],
        qrUrl: res.url
      };
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        "RptCode": 303,
        "InstName": '',
        "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": this.ReportCoCode, //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
         });
    }
    else if (this.Tclcdata['CertType'] == 'MC') {
      var filter: any;
    let qrPayload = { 
      Stuid: this.Tclcdata['StuId'], 
      CertType: this.Tclcdata['CertType'],
       LoginId: parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        InstNo: this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode,
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.Tclcdata['StuId'],
        CertType: this.Tclcdata['CertType'],
        qrUrl: res.url
      };
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        "RptCode": 306,
        "InstName": '',
        "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
      });
    }
    else if (this.Tclcdata['CertType'] == 'OPC') {
      var filter: any;
    let qrPayload = { 
      Stuid: this.Tclcdata['StuId'], 
      CertType: this.Tclcdata['CertType'],
       LoginId: parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        InstNo: this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode,
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.Tclcdata['StuId'],
        CertType: this.Tclcdata['CertType'],
        qrUrl: res.url
      };
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
        "RptCode": 305,
        "InstName": '',
        "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": this.ReportCoCode, //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
      });
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }


  UpdateRank() {

    const payload = {}
    let submitpayload = this.CertScrutinyForm.value
    payload['StuName'] = this.Tclcdata['StuName'],
      payload['StuPRN'] = this.Tclcdata['StuPRN'],
      payload['StuAdd'] = this.ProvisionalData[0]['StuAdd'],
      payload['StuPhone'] = this.ProvisionalData[0]['StuPhone'],
      payload['StuFatherName'] = this.ProvisionalData[0]['StuFatherName'],
      payload['StuMotherName'] = this.ProvisionalData[0]['StuMotherName'],
      payload['LastInst'] = this.ProvisionalData[0]['LastInst'],
      payload['LastRollNo'] = this.ProvisionalData[0]['LastRollNo'],
      payload['LastExam'] = this.ProvisionalData[0]['LastExam'],
      payload['CoCode'] = this.ProvisionalData[0]['CoCode'],
      payload['EmailId'] = this.ProvisionalData[0]['EmailId'],
      payload['EmMonth'] = this.ProvisionalData[0]['EmMonth'],
      payload['regnYear'] = this.ProvisionalData[0]['regnYear'],
      payload['HardCopy'] = this.ProvisionalData[0]['HardCopy'],
      payload['EmDate'] = this.ProvisionalData[0]['EmDate'],
      payload['StuFaculty'] = this.Tclcdata['StuFaculty'],
      payload['StuCourse'] = this.Tclcdata['StuCourse'],
      payload['StuCollege'] = this.Tclcdata['StuCollege'],
      payload['StuExam'] = this.Tclcdata['StuExam'],
      payload['StuBranch'] = this.Tclcdata['StuBranch'],
      payload['SnNo'] = this.Tclcdata['SnNo'],
      payload['CertType'] = this.Tclcdata['CertType'],
      payload['DestClg'] = this.Tclcdata['DestClg'],
      payload['Reason'] = this.Tclcdata['Reason'],
      payload['FeeStatus'] = this.Tclcdata['FeeStatus'],
      payload['CertStatus'] = submitpayload['CertStatus'];
    payload['StuId'] = this.Tclcdata['StuId'],
      payload['TclcId'] = this.Tclcdata['TclcId'],
      payload['Comment'] = submitpayload['Comment'],
      payload['CertScr'] = submitpayload['CertStatus'],
      payload['StuRank'] = submitpayload['rank'],
      payload['TotalCandidate'] = submitpayload['totStudent'],
      payload['StatusBy'] = sessionStorage.getItem('userId')
    payload['RankId'] = this.ProvisionalData[0].RankId


    this.umsService.UpdateRank(payload).subscribe((res) => {
      if (res.status) {
        this.SubmitScrutiny()
        // this.spinner.hide()
      } else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.Tclcdata['CertStatus'] = submitpayload['CertStatus']
          this.ngOnInit()
          this.getScrData()

        })
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  onInputChange(data) {
    const tempData = data.target.value;
    if (tempData > this.CertScrutinyForm.value['totStudent']) {
      let data = {}
      data['message'] = 'Rank cannot be greater than total number of students'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.CertScrutinyForm.controls['rank'].setValue('');
      })
    }
  }

  download(file) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: file
      });
  }

}

